import { __rest } from 'tslib';
import React from 'react';
import AntTextArea from 'antd-core/es/input/TextArea';
import { useTheme } from '../../theme/Theme.js';
import { useAllowClear } from '../../hooks/useAllowClear.js';
import { useSize } from '../../hooks/useSize.js';
import { Container, ResizerIcon } from './styled.js';

const TextArea = React.forwardRef((_a, ref) => {
    var { allowClear, clearIconTooltip, className, fullWidth, onInput, autoSize = false } = _a, props = __rest(_a, ["allowClear", "clearIconTooltip", "className", "fullWidth", "onInput", "autoSize"]);
    const theme = useTheme();
    const allowClearProp = useAllowClear({ allowClear, clearIconTooltip });
    const size = useSize(props.size);
    const textarea = React.useRef(null);
    React.useImperativeHandle(ref, () => textarea.current);
    const handleInput = React.useCallback((event) => {
        var _a, _b;
        onInput === null || onInput === void 0 ? void 0 : onInput(event);
        if (!autoSize)
            return;
        if (!((_b = (_a = textarea === null || textarea === void 0 ? void 0 : textarea.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea) === null || _b === void 0 ? void 0 : _b.textArea))
            return;
        const node = textarea.current.resizableTextArea.textArea;
        node.style.height = `${node.scrollHeight}px`;
    }, [autoSize, onInput]);
    return (React.createElement(Container, { theme: theme, className: className, "$fullWidth": fullWidth },
        React.createElement(AntTextArea, Object.assign({ "data-testid": 'tend-ui-textarea' }, props, { ref: textarea, autoSize: false, allowClear: allowClearProp, size: size, onInput: handleInput })),
        React.createElement(ResizerIcon, { size: 12 })));
});
TextArea.displayName = 'TextArea';

export { TextArea };
//# sourceMappingURL=TextArea.js.map
